import { useState } from 'react';
import { Box, IconButton, UserAvatar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { DefaultRecipientModal } from '../DefaultRecipientModal';
import { Container } from './styled';
export function Item(props) {
    const { recipient, allRecipients, onEdit, onRemove } = props;
    const { firstName, lastName, email } = recipient;
    const [renderEditModal, setRenderEditModal] = useState(false);
    const name = `${firstName} ${lastName}`;
    const showEditModal = () => setRenderEditModal(true);
    const hideEditModal = () => setRenderEditModal(false);
    const handleRemove = () => onRemove(recipient.email);
    const handleEdit = (editedRecipient) => {
        onEdit(editedRecipient);
        hideEditModal();
    };
    return (<Container>
      {renderEditModal && (<DefaultRecipientModal allRecipients={allRecipients} initialValues={recipient} onClose={hideEditModal} onSubmit={handleEdit}/>)}
      <Box alignItems="center" justifyContent="space-between" width="100%">
        <UserAvatar size="sm" title={name} subtitle={email}/>
        <Box alignItems="center" gap="sm">
          <IconButton $round size="xs" appearance="ghost" onClick={handleRemove}>
            <Falcon icon="trash"/>
          </IconButton>
          <IconButton $round size="xs" appearance="secondary" onClick={showEditModal}>
            <Falcon icon="pencil"/>
          </IconButton>
        </Box>
      </Box>
    </Container>);
}
